import React, { useContext, useState, useReducer, useEffect } from "react";
import { Row } from "antd";
import { RootContext } from "../../RootContextProvider";

import "./Appearance.css";
import AppearanceSettings from "./AppearanceSettings";
import { setTheme, setThemeDesign } from "../../utils/appearance";
import { refreshContextProviderPagesOnly } from "../../utils/utils";
import "./Themes.css";

const Appearance = () => {
  const { pages, setPages, setListPages } = useContext(RootContext);
  // const [loading, setLoading] = useState(false);
  const [displayCustom, setDisplayCustom] = useState();
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    // setLoading(true);
    setDisplayCustom(pages.HasCustomTheme ? true : false);
    // setLoading(false);
    // eslint-disable-next-line
  }, [ignored]);

  console.log(pages);
  const refreshContextProvider = async () => {
    let pageToRefresh = localStorage.getItem("pageToLoad");
    await refreshContextProviderPagesOnly(
      setListPages,
      setPages,
      pageToRefresh
    );
    forceUpdate();
  };

  const updateTheme = async (theme, themeFontColor) => {
    console.log(theme);
    if (theme === "none") {
      await setTheme(pages.PageID, "none");
    } else {
      await setTheme(pages.PageID, theme, themeFontColor);
    }
    refreshContextProvider();
  };

  const updateThemeColor = async (color) => {
    await setThemeDesign(pages.PageID, color, undefined, undefined, undefined);
    refreshContextProvider();
  };
  const updateThemeBackgroundSetting = async (setting) => {
    await setThemeDesign(
      pages.PageID,
      undefined,
      undefined,
      undefined,
      undefined,
      setting,
      undefined
    );
    refreshContextProvider();
  };

  const updateBBGC = async (color) => {
    await setThemeDesign(
      pages.PageID,
      undefined,
      color,
      undefined,
      undefined,
      undefined,
      undefined
    );
    refreshContextProvider();
  };

  const updateBTC = async (color) => {
    await setThemeDesign(
      pages.PageID,
      undefined,
      undefined,
      color,
      undefined,
      undefined,
      undefined
    );
    refreshContextProvider();
  };

  const updateBBR = async (color) => {
    await setThemeDesign(
      pages.PageID,
      undefined,
      undefined,
      undefined,
      color,
      undefined,
      undefined
    );
    refreshContextProvider();
  };

  return (
    <Row>
      <AppearanceSettings
        pageDetails={pages}
        updateTheme={updateTheme}
        updateThemeColor={updateThemeColor}
        updateThemeBackgroundSetting={updateThemeBackgroundSetting}
        updateBBGC={updateBBGC}
        updateBTC={updateBTC}
        updateBBR={updateBBR}
        displayCustom={displayCustom}
        refreshContextProvider={refreshContextProvider}
      />
    </Row>
  );
};

export default Appearance;
